module.exports = __webpack_public_path__ + "static/img/logo_login.539bbf18.png";